import { SizableText, RichText } from '@my/ui'
import React from 'react'
import { RedeemOutput } from '../../services/redeem'

interface ErrorDialogPage {
  error?: string
  redemption?: RedeemOutput
}

export function ErrorDialogPage({ error, redemption }: ErrorDialogPage) {
  return <SizableText mb="$2">{error || redemption?.message || 'Something went wrong'}</SizableText>
}
